module.exports = __webpack_public_path__ + "static/media/data-ai-crm.3dabd4fc.png";